module.exports = __webpack_public_path__ + "img/山东大学-295x300.71e22a5e.jpg";